import React, { useEffect, useRef } from 'react';
import { Card, CardContent, Box } from '@mui/material';
import * as echarts from 'echarts';

const AwarenessChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const chart = echarts.init(chartRef.current);
    const option = {
      backgroundColor: '#ffffff',
      tooltip: {
        trigger: 'axis',
  formatter: function (params) {
    const label = params[0]?.axisValue;
    let content = `<strong>Attempt ${label}</strong><br/>`;
    params.forEach(param => {
      content += `${param.marker} ${param.seriesName}: ${param.data}<br/>`;
    });
    return content;
  }
      },
      legend: {
        data: ['Fact', 'Bias', 'Misinformation'],
        top: 13,
        textStyle: {
          color: '#444',
        },
      },
      grid: {
        left: '10%',
        right: '5%',
        bottom: '20%',
        top: '15%',
      },
      xAxis: {
        type: 'category',
        name: 'Attempt',
        nameLocation: 'middle',
        nameGap: 30,
        data: data.map(item => item.attemptLabel),
        axisLabel: {
          color: '#333',
        },
      },
      yAxis: {
        type: 'value',
        name: 'Score',
        nameLocation: 'middle',
        nameGap: 40,
        axisLabel: {
          color: '#333',
        },
        splitLine: {
          lineStyle: {
            color: '#eee',
          },
        },
      },
      series: [
        {
          name: 'Fact',
          type: 'line',
          data: data.map(entry => entry.fact),
          smooth: true,
          lineStyle: { width: 3 },
        },
        {
          name: 'Bias',
          type: 'line',
          data: data.map(entry => entry.bias),
          smooth: true,
          lineStyle: { width: 3 },
        },
        {
          name: 'Misinformation',
          type: 'line',
          data: data.map(entry => entry.misinformation),
          smooth: true,
          lineStyle: { width: 3 },
        },
      ],
    };

    chart.setOption(option);

    const resizeObserver = new ResizeObserver(() => {
      chart.resize();
    });

    resizeObserver.observe(chartRef.current);

    return () => {
      chart.dispose();
      resizeObserver.disconnect();
    };
  }, [data]);

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        ref={chartRef}
        sx={{
          width: '100%',
          height: '300px',
        }}
      />
    </Box>
  );
};

export default AwarenessChart;
